<template>
  <div :class="['d-flex', 'message', bubbleClass]">
    <div>
      <div v-if="isAssistant" class="assistant-bubble bubble mb-4">
        <AgentBrief
          v-if="parsedBrief"
          :brief="parsedBrief"
          @confirm="$emit('confirm', $event)"
        />
        <div class="pa-md-3 pa-2" v-else v-html="renderedContent" ></div>
      </div>
      <div v-else class="user-bubble pa-md-3 pa-2 bubble mb-4">
        {{ message.content }}
      </div>
    </div>
  </div>
</template>


<script>
import MarkdownIt from 'markdown-it'
import AgentBrief from './AgentBrief.vue'

const md = new MarkdownIt({ html: false, linkify: true })


export default {
  name: 'MessageBubble',
  components: { AgentBrief },
  props: { message: { type: Object, required: true } },
  computed: {
    char() { return this.message.streaming ? '_' : '' },
    isAssistant() { return this.message.role === 'assistant' },
    bubbleClass() { return this.isAssistant ? 'justify-start' : 'justify-end' },
    renderedContent() { return md.render(this.message.content + this.char || '') },
    parsedBrief() {
      if (this.message.streaming) return null
      try {
        const obj = JSON.parse(this.message.content)
        if (obj && typeof obj === 'object' && 'project' in obj) return obj
      } catch (e) { /* invalid JSON — not a brief */ }
      return null
    },
  },
}
</script>


<style lang="scss">
.user-bubble { background: var(--app-user-bubble-bg, var(--v-secondary-base)); color: white; border-radius: 12px; max-width: 70%; }
.assistant-bubble { background: var(--app-assistant-msg-bg, var(--v-surface-base, rgba(127,127,127,0.12))); color: var(--app-assistant-bubble-text-msg, inherit); border-radius: 12px; max-width: 80%; }
.bubble {
  max-width: 800px;
}
.message {
  & > div {
    width: 100%;
  }
  table {
    width: 100%;
    display: block;
    overflow-x: scroll;
  }
  table, th, td {
    border: 1px solid #ccc;
    border-collapse: collapse;
  }
  td {
    padding: 4px;
  }
  h1, h2, h3, h4, h5, h6, strong, li::marker, th {
    margin-top: 16px;
    margin-bottom: 8px;
    font-weight: bold;
    color: var(--app-heading-color, var(--v-secondary-base));
  }
  // Keep the markdown heading scale compact inside bubbles (browser default h1 is 2em).
  h1 { font-size: 1.5em; line-height: 1.3; }
  h2 { font-size: 1.25em; line-height: 1.3; }
  hr {
    border: none;
    border-top: 1px solid #ccc;
    margin: 16px 0;
  }
}
</style>